import React, { useEffect, useState } from "react";
import { Grid, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem, Typography } from "@mui/material";
import { Field, useFormikContext } from "formik";
import InputMask from "react-input-mask";
import { LocationCity, Badge, Handyman } from "@mui/icons-material";
import api from "../../../services/api";

const CitySelect = ({ states }) => {
  const { values, handleChange, touched, errors, setFieldValue, initialValues } = useFormikContext();
  const [localCities, setLocalCities] = useState([]);

  useEffect(() => {
    if (values.stateId) {
      api
        .get(`/states/${values.stateId}/cities`)
        .then((response) => {
          const cities = Array.isArray(response.data) ? response.data : response.data.cities || [];
          setLocalCities(cities);
          // Verifica se o cityId inicial está na lista de cidades carregadas
          if (!cities.some((city) => city.id === values.cityId)) {
            setFieldValue("cityId", "");
          }
        })
        .catch((err) => console.error("Erro ao carregar cidades", err));
    } else {
      setLocalCities([]);
      setFieldValue("cityId", "");
    }
  }, [values.stateId, setFieldValue]);

  return (
    <Grid item xs={12} md={6}>
      <FormControl fullWidth margin="normal">
        <InputLabel id="city-label">Cidade</InputLabel>
        <Select
          labelId="city-label"
          name="cityId"
          value={values.cityId || ""}
          label="Cidade"
          onChange={handleChange}
        >
          {localCities.map((city) => (
            <MenuItem key={city.id} value={city.id}>
              {city.name}
            </MenuItem>
          ))}
        </Select>
        {touched.cityId && errors.cityId && (
          <Typography color="error" variant="body2">
            {errors.cityId}
          </Typography>
        )}
      </FormControl>
    </Grid>
  );
};

const AddressForm = ({ states }) => {
  const { values, handleChange, touched, errors, setFieldValue } = useFormikContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <InputMask mask="99999-999" value={values.cep} onChange={handleChange}>
          {() => (
            <TextField
              fullWidth
              name="cep"
              label="CEP"
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocationCity />
                  </InputAdornment>
                ),
              }}
              error={touched.cep && Boolean(errors.cep)}
              helperText={touched.cep && errors.cep}
            />
          )}
        </InputMask>
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="state-label">Estado</InputLabel>
          <Select
            labelId="state-label"
            name="stateId"
            value={values.stateId}
            label="Estado"
            onChange={(e) => {
              handleChange(e);
              setFieldValue("cityId", "");
            }}
          >
            {states.map((state) => (
              <MenuItem key={state.id} value={state.id}>
                {state.name}
              </MenuItem>
            ))}
          </Select>
          {touched.stateId && errors.stateId && (
            <Typography color="error" variant="body2">
              {errors.stateId}
            </Typography>
          )}
        </FormControl>
      </Grid>
      <CitySelect states={states} />
      <Grid item xs={12} md={3}>
        <Field
          as={TextField}
          name="neighborhood"
          label="Bairro"
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCity />
              </InputAdornment>
            ),
          }}
          error={touched.neighborhood && Boolean(errors.neighborhood)}
          helperText={touched.neighborhood && errors.neighborhood}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <Field
          as={TextField}
          name="streetName"
          label="Rua"
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCity />
              </InputAdornment>
            ),
          }}
          error={touched.streetName && Boolean(errors.streetName)}
          helperText={touched.streetName && errors.streetName}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Field
          as={TextField}
          name="streetNumber"
          label="Número"
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Badge />
              </InputAdornment>
            ),
          }}
          error={touched.streetNumber && Boolean(errors.streetNumber)}
          helperText={touched.streetNumber && errors.streetNumber}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Field
          as={TextField}
          name="streetComplement"
          label="Complemento"
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Handyman />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default AddressForm;